/** HelloPeople production (not Lovable, not deleted leftovers). */
export const HELLOPEOPLE_SUPABASE_PROJECT_ID = "ejmrogafsavpaoxillxf";
export const HELLOPEOPLE_SUPABASE_URL = `https://${HELLOPEOPLE_SUPABASE_PROJECT_ID}.supabase.co`;

/** Public anon key for the HelloPeople project. Safe in the browser. */
export const HELLOPEOPLE_SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVqbXJvZ2Fmc2F2cGFveGlsbHhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3MDgzODgsImV4cCI6MjA4NTI4NDM4OH0.1G8ysfGG6MoNjEKJtX72HYSVW0KAXCZ4QiJ1p-HdvaQ";

/**
 * Env values that must never ship. Production Vercel still baked the first one
 * (DNS NXDOMAIN). The second is the old Lovable project (403).
 */
export const REJECTED_SUPABASE_PROJECT_IDS = [
  "nrzqhwrwiuqasngzaeuv",
  "dadlepxokpmqynegcrtm",
] as const;

export type SupabaseEnvInput = {
  url?: string | null;
  publishableKey?: string | null;
};

export type ResolvedSupabaseConfig = {
  url: string;
  publishableKey: string;
  usedFallback: boolean;
};

function mentionsRejectedProject(value: string): boolean {
  return REJECTED_SUPABASE_PROJECT_IDS.some((id) => value.includes(id));
}

export function resolveSupabaseConfig(env: SupabaseEnvInput = {}): ResolvedSupabaseConfig {
  const url = env.url?.trim() ?? "";
  const publishableKey = env.publishableKey?.trim() ?? "";
  const rejected = mentionsRejectedProject(`${url} ${publishableKey}`);

  if (!url || !publishableKey || rejected) {
    return {
      url: HELLOPEOPLE_SUPABASE_URL,
      publishableKey: HELLOPEOPLE_SUPABASE_ANON_KEY,
      usedFallback: true,
    };
  }

  return { url, publishableKey, usedFallback: false };
}

export type RealtimeVoiceWsOptions = {
  mode?: "practice" | "interpreter";
};

/** Browser WebSocket URL. Uses the same host fallback as the auth client. */
export function buildRealtimeVoiceWsUrl(
  accessToken: string,
  env: SupabaseEnvInput = {},
  options: RealtimeVoiceWsOptions = {},
): string {
  if (!accessToken.trim()) {
    throw new Error("Sessão expirada. Entre novamente para praticar.");
  }

  const { url } = resolveSupabaseConfig(env);
  const wsBase = url.replace(/^https:/, "wss:").replace(/\/$/, "");
  const params = new URLSearchParams();
  params.set("access_token", accessToken);
  if (options.mode === "interpreter") {
    params.set("mode", "interpreter");
  }
  return `${wsBase}/functions/v1/realtime-voice?${params.toString()}`;
}
